import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("Please enter your email.");
      return;
    }
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/newsletter`, { email });
      if (data.status === "already_subscribed") {
        toast.info("You're already on the list — thank you for following along.");
      } else {
        toast.success("Welcome to the journey — check your inbox.");
      }
      setEmail("");
    } catch (err) {
      if (err.response?.status === 422) toast.error("Please enter a valid email address.");
      else toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="py-16 lg:py-20 bg-[#7F9F43]" data-testid="newsletter-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-6">
              <p className="text-xs tracking-[0.3em] uppercase text-white/60 font-semibold mb-3">
                Stay updated
              </p>
              <h2 className="text-2xl sm:text-3xl font-light tracking-tight text-white">
                Follow our <span className="font-serif-italic">journey.</span>
              </h2>
              <p className="mt-3 text-white/75 text-sm md:text-base leading-relaxed max-w-md">
                Be the first to hear about Romii's progress — milestones, collaborations, and the
                moments that matter. Only when there's something worth sharing.
              </p>
            </div>
            <div className="lg:col-span-5 lg:col-start-8">
              <form onSubmit={submit} className="flex gap-3" data-testid="newsletter-form">
                <input
                  type="email"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="newsletter-input-email"
                  className="flex-1 rounded-full bg-white/15 border border-white/25 px-6 py-3.5 text-sm text-white placeholder:text-white/50 focus:outline-none focus:border-white/60 focus:bg-white/20 transition-[border-color,background-color] duration-300"
                />
                <button
                  type="submit"
                  disabled={sending}
                  data-testid="newsletter-submit-button"
                  className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3.5 text-sm font-semibold text-[#5e7530] hover:bg-[#f5f8ec] hover:-translate-y-0.5 transition-[background-color,transform] duration-300 disabled:opacity-60 shrink-0"
                >
                  {sending ? <Loader2 size={15} className="animate-spin" /> : <ArrowRight size={15} />}
                  Subscribe
                </button>
              </form>
              <p className="mt-3 text-xs text-white/50">No spam, ever. Unsubscribe anytime.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
